// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__38_HX","alertIcon":"ConfirmModal_alertIcon__XDvqH"};